import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../../modules/auth/services/auth/auth.service';

const BUILDER_ONLY_ALLOWLIST = ['/builders', '/my-profile'];

export const builderAccessGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.hasFullPortalAccess()) {
    return true;
  }

  const url = state.url.split('?')[0];

  // Orphan Builder Requests path → canonical list (Pending Approval tab).
  if (url === '/builder-requests' || url.startsWith('/builder-requests/')) {
    void router.navigate(['/builders'], {
      queryParams: { status: 'request_sent' },
    });
    return false;
  }

  const allowed = BUILDER_ONLY_ALLOWLIST.some(
    path => url === path || url.startsWith(`${path}/`),
  );

  if (allowed) {
    return true;
  }

  void router.navigate(['/builders']);
  return false;
};
